export default function Contact() {
  return (
    <>
      <div class="row_contact">
        <div class="column_contact">
          <div class="container_float">
            <h2>Contact :</h2>
            <br />
            <br />
            <p className="contact_content_question">
              Wanna grab some tea or go for a walk?
            </p>
            <br />
            <br />
            <p className="contact_content">
              My Email : perrault.victor92@gmail.com
            </p>
            <br />
            <p className="contact_content">
              My Linkedin :{" "}
              <a href="https://www.linkedin.com/in/victor-perrault-32b16b15b/">
                Victor Perrault
              </a>
            </p>
            <br />
            <p className="contact_content">
              My Instagram :{" "}
              <a href="https://instagram.com/victor_prlt/">@victor_prlt</a>
            </p>
            <br />
            <p className="contact_content">
              My Artsation :{" "}
              <a href="https://victorsketches.artstation.com/">
                Victor Perrault
              </a>
            </p>
          </div>
        </div>
      </div>
      <div class="footer_projects">
        <p>© Victor Perrault 2023. Currently in Hong Kong</p>
      </div>
    </>
  );
}
